export default "__VITE_ASSET__CJGf_L_E__"